class CustomerSupportForm extends HTMLElement {
    reason_input_el_selector = '#csf_reason_input'
    order_number_input_el_selector = '#csf_order_number_input'
    name_input_el_selector = '#csf_name_input'
    email_input_el_selector = '#csf_email_input'
    message_input_el_selector = '#csf_message_input'
    attachments_input_el_selector = '#csf_attachments_input'
    MAX_SIZE = 50 * 1024 * 1024; // 50MB
    constructor() {
        super();
        this.form = this.querySelector('form')
        this.submitEl = this.querySelector('.form-actions input[type="submit"');
        this.attachmentInput = this.querySelector(this.attachments_input_el_selector);
        this.validationMsg = JSON.parse(this.dataset.validationMsg.replaceAll('=>', ':'));
    }

    connectedCallback() {
        this.addEventListener('submit', this.handleUserRegistration.bind(this))
        window.luxoLoadSwal?.();
        this.attachmentInput.addEventListener('change', (event) => {
            const fileInput = event.target;
            if (fileInput.files.length > 0) {
                fileInput.classList.add('has-file');
            }
            else {
                fileInput.classList.remove('has-file');
            }
        });
        this.validation()
    }

    async validation() {
        const nod = await window.waitForMod("nod")
        const formValidation = await window.waitForMod("formValidation")
        if (!nod || !formValidation) {
            console.error("Required modules are not loaded")
            return
        }
        const validationModel = [
            formValidation.buildRequiredNodValidation(this.name_input_el_selector, 'Name'),
            formValidation.buildRequiredNodValidation(this.email_input_el_selector, 'Email'),
            formValidation.buildRequiredNodValidation(this.reason_input_el_selector, 'Reason'),
            formValidation.buildRequiredNodValidation(this.order_number_input_el_selector, 'Order Number'),
            formValidation.buildRequiredNodValidation(this.message_input_el_selector, 'Message'),
            {
                selector: this.email_input_el_selector,
                validate: 'email',
                errorMessage: this.validationMsg.email_address
            },
            {
                selector: this.attachments_input_el_selector,
                validate: (cb, value) => {
                    const files = this.attachmentInput.files;
                    for (const file of files) {
                        if (file.size > this.MAX_SIZE) {
                            cb(false);
                            return;
                        }
                    }
                    cb(true);
                },
                errorMessage: 'File exceeds maximum size of 50MB.'
            }
        ]
        this.formValidator = nod({ submit: this.submitEl });
        this.formValidator.add(validationModel)
        this.submitEl.removeAttribute('disabled');
    }

    toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                resolve(base64String);
            };
            reader.onerror = error => reject(error);
        });
    }

    async handleUserRegistration(evt) {
        evt.preventDefault()
        this.formValidator.performCheck();
        if (this.formValidator.areAll('valid')) {
            let msg = "Server is currently experiencing a delay. Please try again.",
                icon = "info"

            await window.luxoLoadSwal?.();
            this.loading()
            const formData = new FormData(this.form);
            try {
                const res = await api.luxo.createService().post(
                    'shopify/endpoints/contact-us/submissions.php',
                    formData
                )
                if (res.success) {
                    if (res.data.status === "success") {
                        msg = "Thanks for leaving a review! We’re grateful for your support."
                        icon = "success"
                    }
                    else {
                        msg = res.data.message || "An error occurred while processing your request. Please try again later."
                        icon = "error"
                    }
                }
                else {
                    throw new Error("Network response was not ok");
                }
            } catch (error) {
                icon = "error"
                msg = "An error occurred while processing your request. Please try again later."
            }
            finally {
                window.swal?.hideLoading();
                this.showMsg(msg, icon);
            }

            setTimeout(() => {
                if (window.swal && window.swal.isLoading()) {
                    window.swal.close()  //taking too long to load
                    this.showMsg(msg, icon)
                }
            }, 15000);
        }
    }

    loading() {
        if (window.swal)
            window.swal.fire({
                allowOutsideClick: false,
                didOpen: () => {
                    window.swal.showLoading();
                },
            })
    }

    showMsg(msg, icon) {
        window.swal && window.swal.fire({
            customClass: {
                container: "home-stylist-swal",
                confirmButtonClass: "home-stylist-swal-confirmBtn",
            },
            confirmButtonColor: "#282829",
            showCloseButton: true,
            width: '469px',
            text: msg,
            icon
        })
    }
}

customElements.define('customer-support-form', CustomerSupportForm);
